import type { CurrencyCode } from '../../../../../types';

/*
ECMA-402 IsWellFormedCurrencyCode: ровно 3 ASCII-буквы.
Справочник валют Intl не проверяет: неизвестный, но well-formed код
не бросает исключение, а печатается как есть ("1 234,50 XTS").
Всё остальное (Undefined, YandexDemoRub, Bonuses) роняет
конструктор Intl.NumberFormat с RangeError.

Intl.supportedValuesOf('currency') здесь не годится: это список
актуальных валют CLDR, в него не входят рабочие для нас RUR и XTS.
*/
const INTL_CURRENCY_CODE_PATTERN = /^[A-Za-z]{3}$/;

export const checkIsIntlCurrencyCode = (
    currency: CurrencyCode
): boolean => (
    INTL_CURRENCY_CODE_PATTERN.test(currency)
);
